<!-- 研发型订单服务规则对话框 -->
<template>
  <el-dialog
    :visible.sync="visible"
    top="7vh"
    width="720px"
    :show-close="true"
    custom-class="order-rule-dialog"
    @close="handleClose"
  >
    <div class="dialog-content">
      <h3 class="dialog-title">研发型订单服务规则详情</h3>

      <div class="price-advantage-wrapper">
        <div class="price-advantage-header">
          <span class="price-advantage-title">研发型费用优势</span>
        </div>
        <div class="price-advantage-content">
          <div class="price-advantage-item">
            <div class="price-advantage-label">SMT贴片费</div>
            <div class="price-advantage-value text-red">免费</div>
          </div>
          <div class="price-advantage-item">
            <div class="price-advantage-label">开机费（工程费）</div>
            <div class="price-advantage-value">
              <span class="price-num">¥50</span> <span class="price-unit">/ 单面</span>
            </div>
            <div class="price-advantage-value">
              <span class="price-num">¥280</span> <span class="price-unit">/ 双面</span>
            </div>
          </div>
          <div class="price-advantage-item">
            <div class="price-advantage-label">钢网费</div>
            <div class="price-advantage-value">
              <span class="price-num">免费</span> <span class="price-unit">/ 单面</span>
            </div>
            <div class="price-advantage-value">
              <span class="price-num">¥100</span> <span class="price-unit">/ 双面</span>
            </div>
          </div>
        </div>
      </div>

      <div class="rule-table-wrapper">
        <table class="rule-table">
          <thead>
            <tr>
              <th class="col-category"><div class="cell">分类</div></th>
              <th class="col-type">
                <div class="cell">
                  <img class="type-icon" src="@@/assets/img/smt/order_type/icon-01.png" />
                  <strong>研发型</strong>（自助极速）
                </div>
              </th>
              <th class="col-type">
                <div class="cell">
                  <img class="type-icon" src="@@/assets/img/smt/order_type/icon-02.png" />
                  <strong>标准型</strong>（人工护航）
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="col-category"><div class="cell">下单类型</div></td>
              <td :class="{ 'text-danger': !developOrderSupport.orderType }"><div class="cell">PCB在华秋定制 + BOM自助匹配选型</div></td>
              <td :class="{ 'text-danger': !developOrderSupport.orderType }"><div class="cell">无限制</div></td>
            </tr>
            <tr>
              <td class="col-category"><div class="cell">PCB尺寸</div></td>
              <td :class="{ 'text-danger': !developOrderSupport.pcbSize }"><div class="cell">50mm*50mm - 150mm*220mm</div></td>
              <td :class="{ 'text-danger': !developOrderSupport.pcbSize }"><div class="cell">无限制</div></td>
            </tr>
            <tr>
              <td class="col-category"><div class="cell">PCB层数</div></td>
              <td :class="{ 'text-danger': !developOrderSupport.pcbLayers }"><div class="cell">仅限2、4层</div></td>
              <td :class="{ 'text-danger': !developOrderSupport.pcbLayers }"><div class="cell">1-32层</div></td>
            </tr>
            <tr>
              <td class="col-category"><div class="cell">下单数量</div></td>
              <td :class="{ 'text-danger': !developOrderSupport.quantity }"><div class="cell">5片 或者 10片 全贴</div></td>
              <td :class="{ 'text-danger': !developOrderSupport.quantity }"><div class="cell">不限数量</div></td>
            </tr>
            <tr>
              <td class="col-category"><div class="cell">板厚限制</div></td>
              <td :class="{ 'text-danger': !developOrderSupport.boardThickness }"><div class="cell">1.6mm</div></td>
              <td :class="{ 'text-danger': !developOrderSupport.boardThickness }"><div class="cell">0.2 ~ 5mm自选</div></td>
            </tr>
            <tr>
              <td class="col-category"><div class="cell">物料种类(BOM)</div></td>
              <td :class="{ 'text-danger': !developOrderSupport.bomMaterial }"><div class="cell">&lt;60种</div></td>
              <td :class="{ 'text-danger': !developOrderSupport.bomMaterial }"><div class="cell">无限制</div></td>
            </tr>
            <tr>
              <td class="col-category"><div class="cell">特殊工艺</div></td>
              <td :class="{ 'text-danger': !developOrderSupport.specialProcess }"><div class="cell">不支持特殊工艺/三防漆/阶梯钢网</div></td>
              <td :class="{ 'text-danger': !developOrderSupport.specialProcess }"><div class="cell">支持全部特殊工艺</div></td>
            </tr>
            <tr>
              <td class="col-category"><div class="cell">样品图确认</div></td>
              <td :class="{ 'text-danger': !developOrderSupport.sampleConfirm }"><div class="cell">不支持</div></td>
              <td :class="{ 'text-danger': !developOrderSupport.sampleConfirm }"><div class="cell">支持</div></td>
            </tr>
            <tr>
              <td class="col-category"><div class="cell">选型结果</div></td>
              <td><div class="cell">不支持华秋代配订购</div></td>
              <td><div class="cell">无要求</div></td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="rule-tips">
        <img class="warning-icon" src="@@/assets/img/icons/icon_warning.png" />
        <span>特别说明：研发型订单通过全自动化流程实现极速交付。选择该模式即代表您认可系统自动解析结果，并自行承担因BOM封装不匹配导致的"自动空贴"风险。</span>
      </div>
      <div class="dialog-footer">
        <div class="btn-confirm" @click="handleConfirm">我已了解规则</div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'OrderRuleDialog',
  props: {
    // 控制对话框显示/隐藏
    value: {
      type: Boolean,
      default: false
    },
    developOrderSupport: {
      type: Object,
      default: () => ({
        orderType: true,
        pcbSize: true,
        pcbLayers: true,
        quantity: true,
        boardThickness: true,
        bomMaterial: true,
        specialProcess: true,
        sampleConfirm: true
      })
    }
  },
  computed: {
    visible: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    handleConfirm() {
      this.visible = false
      this.$emit('confirm')
    },
    handleClose() {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .order-rule-dialog {
  .el-dialog__header {
    padding: 0;
    border-bottom: none;
  }
  .el-dialog__body {
    padding: 0!important;
  }
  .el-dialog__headerbtn {
    top: 16px;
    right: 16px;
    font-size: 18px;
    .el-dialog__close {
      color: #909399;
    }
  }
}

.dialog-content {
  padding: 20px 24px 24px;
}

.dialog-title {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
  margin: 0 0 16px 0;
}

.price-advantage-wrapper {
  width: 672px;
  height: 160px;
  background: #f3fbf8;
  border: 1px solid #d0ede3;
  border-radius: 8px;
  margin-bottom: 10px;
}

.price-advantage-header {
  text-align: center;
  margin-bottom: 12px;
}

.price-advantage-title {
  display: inline-block;
  background-image: url('~@@/assets/img/smt/order_type/title-bg.png');
  background-size: cover;
  background-repeat: no-repeat;
  background-size: 222px;
  color: #ffffff;
  font-size: 16px;
  font-weight: bold;
  line-height: 32px;
  height: 32px;
  width: 222px;
  transform: translateY(-3px);
}

.price-advantage-content {
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.price-advantage-item {
  text-align: center;
  width: 200px;
  height: 96px;
  background: linear-gradient(180deg, #ffffff, #f4fbf9);
  border: 1px solid #ffffff;
  border-radius: 8px;
  box-shadow: 0px 3px 6px 0px rgba(21,166,117,0.10); 
}

.price-advantage-label {
  padding-top: 10px;
  font-size: 14px;
  color: #333333;
  margin-bottom: 4px;
}

.price-advantage-value {
  font-size: 14px;
  font-weight: 500;
  line-height: 1;
  margin-bottom: 5px;
  .price-num {
    font-size: 16px;
    font-weight: bold;
    color: #f56c6c;
  }

  .price-unit {
    color: #999999;
    font-size: 12px;
    font-weight: normal;
  }
}

.text-red {
  font-size: 16px;
  font-weight: bold;
  color: #f56c6c;
}

.rule-table-wrapper {
  border: 1px solid #F2F3F5;
  border-radius: 4px;
  overflow: hidden;
}

.rule-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
  color: #333333;

  thead {
    background-color: #f8f9fc;
  }

  th, td {
    text-align: center;
    border-bottom: 1px solid #F2F3F5;
    border-right: 1px solid #F2F3F5;

    &:last-child {
      border-right: none;
    }
  }

  th .cell {
    min-height: 48px;
    padding: 6px 12px;
    line-height: 20px;
    font-weight: 500;
    color: #303133;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
  }

  td .cell {
    min-height: 40px;
    padding: 6px 16px;
    line-height: 20px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    box-sizing: border-box;
  }

  tbody tr:last-child td {
    border-bottom: none;
  }

  .col-category {
    width: 136px;
    text-align: center;
    font-weight: 500;
    color: #666666;
    background: #fbfbfc;
  }

  .col-type {
    width: 220px;
  }

  .type-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 18px;
    height: 18px;
    border-radius: 4px;
    font-size: 11px;
    margin-right: 4px;
    line-height: 1;
  }

  .text-danger {
    background-color: #fff3f3;
    color: #ff1b1b;
  }
}

.rule-tips {
  margin-top: 12px;
  padding: 10px 12px;
  background-color: #FFF9F3;
  border-radius: 4px;
  font-size: 12px;
  color: #AD8C6D;
  line-height: 1.6;
  display: flex;
  align-items: flex-start;

  .warning-icon {
    width: 14px;
    height: 14px;
    margin-right: 6px;
    margin-top: 2px;
    flex-shrink: 0;
  }

  span {
    flex: 1;
  }
}

.dialog-footer {
  margin-top: 20px;
  text-align: right;

  .btn-confirm {
    display: inline-block;
    width: 120px;
    height: 32px;
    line-height: 32px;
    background: #15a675;
    border-radius: 16px;
    background-color: #15A675;
    border-color: #15A675;
    font-size: 14px;
    color: #ffffff;
    text-align: center;
    cursor: pointer;

    &:hover, &:focus {
      background-color: #128d64;
      border-color: #128d64;
    }

    &:active {
      background-color: #128d64;
      border-color: #128d64;
    }
  }
}
</style>